import { VALIDATE_TOKEN } from '../action-types'

const initialState = { current: {} }
const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VALIDATE_TOKEN:
      return { ...state, current: payload }
    default:
      return state
  }
}
export default userReducer